let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("033A0")).then(() => parcelRequire('2GmUQ'));